export const DELIVERY_EVENT_LABEL = `{PREFIX} by {EVENT} for`;
export const DELIVERY_EVENT_MORE_OPTIONS = 'More options';
export const LATE_DELIVERY_EVENT_LABEL = `Late for {EVENT}`;
